import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Image } from 'antd';
import { getEvidencias } from 'api/solicitudes';

const ModalEvidencias = ({
  visible,
  setVisible,
  queja,
  setLoading,
}) => {
  const [evidencias, setEvidencias] = useState([]);

  const fetchEvidencias = async () => {
    setLoading(true);
    const _evidencias = await getEvidencias({ queja });
    setEvidencias(_evidencias.filter((e) => e.queja === queja));
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      fetchEvidencias();
    }
  }, [visible]);

  const preview = {
    visible,
    onVisibleChange: (vis) => {
      setEvidencias([]);
      setVisible(vis);
    },
    mask: false,
  };

  return (
    <Row gutter={10} style={{ display: visible ? 'block' : 'none' }}>
      <Image.PreviewGroup preview={preview}>
        {evidencias.map((e) => (
          <Image
            key={e.id}
            src={e.archivo}
            alt={e.descripcion}
            fallback="https://via.placeholder.com/500"
            height={200}
            width={200}
          />
        ))}
      </Image.PreviewGroup>
    </Row>
  );
};

ModalEvidencias.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  queja: PropTypes.number.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default ModalEvidencias;
